import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../../../config/i18n';
import DropdownSelect from '../../../utils/dropdownSelect/DropdownSelect';

import './reviews.css';

const ratingCategories = ['area', 'comfort', 'value', 'cleanliness'];

const reviewMaxChars = 2000;

export default class ReviewForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ratingArea: (props.ratings && props.ratings.ratingArea) || undefined,
      ratingComfort: (props.ratings && props.ratings.ratingComfort) || undefined,
      ratingValue: (props.ratings && props.ratings.ratingValue) || undefined,
      ratingCleanliness: (props.ratings && props.ratings.ratingCleanliness) || undefined,
      reviewText: props.reviewText || '',
      npsScore: props.npsScore || undefined,
      validationErrors: {},
    };
    this.handleNpsChange = this.handleNpsChange.bind(this);
    this.handleReviewTextChange = this.handleReviewTextChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  getRatingOptions() {
    return [
      { label: I18n.t('reviews.rating_no_selection'), value: '' },
      { label: I18n.t('reviews.rating_selection_1'), value: 1 },
      { label: I18n.t('reviews.rating_selection_2'), value: 2 },
      { label: I18n.t('reviews.rating_selection_3'), value: 3 },
      { label: I18n.t('reviews.rating_selection_4'), value: 4 },
      { label: I18n.t('reviews.rating_selection_5'), value: 5 },
    ];
  }

  getErrorClass(fieldName) {
    if (!this.props.validationMode) {
      return '';
    }

    if (this.state.validationErrors[fieldName]) {
      return 'reviews__error';
    }
    return '';
  }

  hasValidationErrors() {
    return Object.keys(this.state.validationErrors).length > 0;
  }

  validateForm() {
    const validationErrors = {};
    if (!this.state.ratingArea) {
      validationErrors.ratingarea = true;
    }
    if (!this.state.ratingComfort) {
      validationErrors.ratingcomfort = true;
    }
    if (!this.state.ratingValue) {
      validationErrors.ratingvalue = true;
    }
    if (!this.state.ratingCleanliness) {
      validationErrors.ratingcleanliness = true;
    }
    if (!this.state.ratingCleanliness) {
      validationErrors.ratingcleanliness = true;
    }
    if (this.state.reviewText.length === 0 || this.state.reviewText.length > reviewMaxChars) {
      validationErrors.reviewText = true;
    }
    if (!this.state.npsScore) {
      validationErrors.npsScore = true;
    }

    this.setState({ validationErrors });
    return Object.keys(validationErrors).length > 0;
  }

  handleRatingChange(e, category) {
    const value = parseInt(e.value, 10);
    switch (category) {
      case 'area':
        this.setState({ ratingArea: value }, this.validateForm);
        break;
      case 'comfort':
        this.setState({ ratingComfort: value }, this.validateForm);
        break;
      case 'value':
        this.setState({ ratingValue: value }, this.validateForm);
        break;
      case 'cleanliness':
        this.setState({ ratingCleanliness: value }, this.validateForm);
        break;
      default:
    }
  }

  currentRatingValue(category) {
    switch (category) {
      case 'area':
        return this.state.ratingArea;
      case 'comfort':
        return this.state.ratingComfort;
      case 'value':
        return this.state.ratingValue;
      case 'cleanliness':
        return this.state.ratingCleanliness;
      default:
        return undefined;
    }
  }

  handleReviewTextChange(event) {
    const reviewText = event.currentTarget.value || '';
    if (reviewText.length > reviewMaxChars) {
      return;
    }

    this.setState(
      {
        reviewText,
      },
      this.validateForm,
    );
  }

  handleNpsChange(event) {
    this.setState(
      {
        npsScore: parseInt(event.currentTarget.value, 10),
      },
      this.validateForm,
    );
  }

  stageReview() {
    this.props.onDoStaging(
      {
        ratingArea: this.state.ratingArea,
        ratingComfort: this.state.ratingComfort,
        ratingValue: this.state.ratingValue,
        ratingCleanliness: this.state.ratingCleanliness,
      },
      this.state.reviewText.trim(),
      this.state.npsScore,
    );
  }

  resetScroll() {
    if (typeof window !== 'undefined' && window.scrollTo) {
      window.scrollTo(0, 0);
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    const validationErrors = this.validateForm();
    if (!validationErrors) {
      this.stageReview();
      this.props.setValidationMode(false);
    } else {
      this.props.setValidationMode(true);
    }
    this.resetScroll();
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="reviews__question">{I18n.t('reviews.rating_headline')}</div>
        {ratingCategories.map((cat) => (
          <div key={cat} className="reviews__rating-row">
            <div className={`reviews__rating-label ${this.getErrorClass(`rating${cat}`)}`}>
              {I18n.t(`reviews.question_${cat}`)}
            </div>
            <div className="reviews__rating-input">
              <DropdownSelect
                selectedIndex={this.currentRatingValue(cat) || 0}
                options={this.getRatingOptions()}
                disabled={false}
                className="reviews__select"
                onChange={(e) => this.handleRatingChange(e, cat)}
              />
            </div>
          </div>
        ))}
        <div
          className={`reviews__question reviews__question--non-top ${this.getErrorClass(
            'reviewText',
          )}`}
        >
          {I18n.t('reviews.review_headline')}
        </div>
        <textarea
          className="reviews__textarea"
          rows="10"
          value={this.state.reviewText}
          onChange={this.handleReviewTextChange}
        />
        <div className="reviews__charlimit">
          {I18n.t('reviews.remaining_chars')}: {reviewMaxChars - this.state.reviewText.length}/
          {reviewMaxChars}
        </div>
        <div
          className={`reviews__question reviews__question--non-top ${this.getErrorClass(
            'npsScore',
          )}`}
        >
          {I18n.t('reviews.nps_headline')}
        </div>
        <div className="reviews__ratingwrapperouter">
          <div className="reviews__ratingwrapper">
            <div className="reviews__ratingtitlelabels">
              <div>{I18n.t('reviews.nps_unlikely')}</div>
              <div>{I18n.t('reviews.nps_very_likely')}</div>
            </div>
            <div className="reviews__nps-score-wrapper">
              {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((count) => (
                <div key={`option${count}`} className="reviews__nps-ratings">
                  <input
                    className="reviews__nps-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id={`ratingform${count}`}
                    value={count}
                    checked={count === this.state.npsScore}
                    onChange={this.handleNpsChange}
                  />
                  <label className="reviews__nps-label" htmlFor={`ratingform${count}`}>
                    {count}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="reviews__submitrow">
          <input
            type="submit"
            value={I18n.t('reviews.confirm')}
            className="reviews__submitbutton"
          />
        </div>
      </form>
    );
  }
}

ReviewForm.propTypes = {
  ratings: PropTypes.shape({
    ratingArea: PropTypes.number.isRequired,
    ratingComfort: PropTypes.number.isRequired,
    ratingValue: PropTypes.number.isRequired,
    ratingCleanliness: PropTypes.number.isRequired,
  }),
  reviewText: PropTypes.string,
  npsScore: PropTypes.number,
  validationMode: PropTypes.bool.isRequired,
  setValidationMode: PropTypes.func.isRequired,
  onDoStaging: PropTypes.func.isRequired,
};
